import React, { useEffect, useState } from 'react';
import './ShortServicesSection.css';
import dummy_factory from '../../assets/images/dummy_factory.png';
import dummy_license from '../../assets/images/dummy_license.png';
import dummy_approval from '../../assets/images/dummy_approval.png';
import dummy_others from '../../assets/images/dummy_others.png';
export default function ShortServicesSection() {
    const [animate, setAnimate] = useState(false);

  useEffect(() => {
    // Trigger animation after component mounts
    setTimeout(() => setAnimate(true), 300); // Delay for smooth effect
  }, []);
  return (
    <>
     <section className="services_pk8">
      <h2 className={`section-title_pk8 ${animate ? 'fade-in' : ''}`}>Our Services</h2>
      <div className="services-grid_pk8">
        {/* Engineering Service Card */}
        <div className={`service-card_pk8 ${animate ? 'fade-in' : ''}`}>
          <img src={dummy_factory} alt="Engineering" className="service-icon_pk8" />
          <h3>Engineering</h3>
          <p>We offer expert engineering solutions to help your business meet the industrial standards and improve operational efficiency.</p>
          {/* <a href="/services/engineering" className="cta-button_pk8 secondary">Learn More</a> */}
        </div>

        {/* Licensing Service Card */}
        <div className={`service-card_pk8 ${animate ? 'fade-in' : ''}`}>
          <img src={dummy_license } alt="Licensing" className="service-icon_pk8" />
          <h3>Licensing</h3>
          <p>Our licensing services ensure that your business complies with all the necessary industrial regulations for smooth operations.</p>
          {/* <a href="/services/licensing" className="cta-button_pk8 secondary">Learn More</a> */}
        </div>

        {/* NOCs/Approvals/Permits Service Card */}
        <div className={`service-card_pk8 ${animate ? 'fade-in' : ''}`}>
          <img src={dummy_approval} alt="NOCs/Approvals/Permits" className="service-icon_pk8" />
          <h3>NOCs</h3>
          <p>We handle the paperwork and compliance to help you secure necessary approvals, NOCs, and permits for your operations.</p>
          {/* <a href="/services/nocs-approvals-permits" className="cta-button secondary">Learn More</a> */}
        </div>

        {/* Others Service Card */}
        <div className={`service-card_pk8 ${animate ? 'fade-in' : ''}`}>
          <img src={dummy_others} alt="Others" className="service-icon_pk8" />
          <h3>Others</h3>
          <p>We provide various other services tailored to meet the specific needs of your business in the industrial sector.</p>
          {/* <a href="/services/others" className="cta-button_pk8 secondary">Learn More</a> */}
        </div>
      </div>
    </section>
    
    
    
    </>
  )
}
